var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "new-dashboard" },
    [
      _c("WalletWidget", {
        staticClass: "new-dashboard__wallet-widget",
        attrs: {
          currentAsset: _vm.currentToken,
          tronSum: _vm.sumTron,
          isShowWithdrawal: _vm.isShowWithdrawalWidget
        },
        on: _vm._d({}, [
          _vm.commonEvents.assetChangeEvent,
          _vm.setCurrentAsset,
          _vm.commonEvents.walletTopUpEvent,
          _vm.walletTopUpHandler,
          _vm.commonEvents.walletWithdrawalEvent,
          _vm.wizdrawalHandler
        ])
      }),
      _vm._v(" "),
      _c(_vm.getCurrentComponent, {
        tag: "componnet",
        staticClass: "new-dashboard__operations-widget",
        on: { refreshBalances: _vm.loadBalances }
      }),
      _vm._v(" "),
      _c("CryptoChart", {
        staticClass: "new-dashboard__chart-widget",
        attrs: { balancesReady: _vm.balancesReady }
      }),
      _vm._v(" "),
      _c("LastTransactionsWidget", {
        staticClass: "new-dashboard__history-widget",
        attrs: { currentAsset: _vm.currentToken }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f797000", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f797000","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/dashboard/index/Dashboard.Index.vue
// module id = PD+X
// module chunks = 1